import { render, staticRenderFns } from "./batchMatchingResults.vue?vue&type=template&id=d6e95eb4&scoped=true"
import script from "./batchMatchingResults.vue?vue&type=script&lang=js"
export * from "./batchMatchingResults.vue?vue&type=script&lang=js"
import style0 from "./batchMatchingResults.vue?vue&type=style&index=0&id=d6e95eb4&prod&lang=scss&scoped=true"
import style1 from "./batchMatchingResults.vue?vue&type=style&index=1&id=d6e95eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e95eb4",
  null
  
)

export default component.exports